import { RecommendationFeature } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
export const PRE_SUGGESTIONS_FALLBACK_QUERY = 'mystunningwebsite';
export const usePreSuggestionsQuery = fallbackQuery => DomainsApiClient.hooks.useListRecommendations({
  query: fallbackQuery,
  features: [RecommendationFeature.USE_BUSINESS_INFO],
  paging: {
    limit: 3
  }
}, true, {
  cacheTime: Infinity,
  staleTime: Infinity,
  useErrorBoundary: false
});
export const isPreSuggestionsHidden = _ref => {
  let error = _ref.error,
    isLoading = _ref.isLoading,
    recommendations = _ref.recommendations;
  return Boolean(error) || !isLoading && !recommendations.length;
};
export const usePreSuggestionsHidden = function (fallbackQuery) {
  if (fallbackQuery === void 0) {
    fallbackQuery = PRE_SUGGESTIONS_FALLBACK_QUERY;
  }
  const _usePreSuggestionsQue = usePreSuggestionsQuery(fallbackQuery),
    data = _usePreSuggestionsQue.data,
    isLoading = _usePreSuggestionsQue.isLoading,
    error = _usePreSuggestionsQue.error;
  return isPreSuggestionsHidden({
    error,
    isLoading,
    recommendations: (data == null ? void 0 : data.recommendations) ?? []
  });
};
//# sourceMappingURL=usePreSuggestionsQuery.js.map